import Footer from './container';

export default Footer;
